import React, { useState, useCallback, useEffect } from 'react'
import Slider from 'react-slick'
import Banner1 from 'custom/assets/dashboard/banner-2.png'
import '../../../styles/adBanner.css'
import AccountsService from '../../../services/accounts.service'
import Loading from 'custom/assets/loaders/Loading'
import { useDispatch, useSelector } from 'react-redux'

import { getOffersSelector } from '../../../selectors'
import { setOffers } from '../../../actions'

export default function AdBanner() {
  const [offerList, setOfferList] = useState([])
  const [loading, setLoading] = useState(false)
  const offers = useSelector(getOffersSelector)
  const dispatch = useDispatch()

  useEffect(() => {
    fetchOffers()
  }, [])

  const fetchOffers = useCallback(async () => {
    try {
      if(offers?.length ===0){
        setOfferList(offers)
        return;
      }
      const response = await AccountsService.getOffers()
      setOfferList(response.offers)
      dispatch(setOffers(response.offers))

      setLoading(false)
    } catch (err) {
      setLoading(false)
    }
  }, [])

  function renderLoading() {
    return (
      <div className='mx-4 rounded d-flex justify-content-center align-items-center'>
        <Loading width='50px' height='50px' />
      </div>
    )
  }

  const settings = {
    dots: false,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
  }
  const bannerList = [
    {
      img: Banner1,
    },
  ]

  return (
    <React.Fragment>
      <Slider {...settings}>
        {offerList.length === 0 &&
          bannerList.map((b, i) => (
            <div key={i} className=''>
              <div>
                <img src={b.img} alt='' height='138' width='100%' />
              </div>
            </div>
          ))}

        {offerList.length > 0 &&
          offerList.map((item, index) => (
            <div key={index} className=''>
              <div>
                <img
                  src={`data:image/png;base64, ${item.offerImage}`}
                  width='100%'
                  height='138'
                  alt='offers'
                />
              </div>
            </div>
          ))}

        {/* {offerList.length > 0 && (
          <>
            {offerList.map((item, index) => (
              <div key={index}>
                <div className=''>
                  <img
                    src={`data:image/png;base64, ${item.offerImage}`}
                    width='100%'
                    height='138'
                    alt='offers'
                  />
                </div>
              </div>
            ))}
          </>
        )} */}
      </Slider>
    </React.Fragment>
  )
}
